export default __webpack_public_path__ + "static/Pala_14-a07995aa233f469f21010e771bca8a9b.png";